/* eslint-disable no-use-before-define */

import globalApps from '@bingads-webui-clientcenter/global-apps';
import { getUrlBuilders } from '@bingads-webui-clientcenter/url-builder-base';


const UrlBuilders = getUrlBuilders({
  ccBaseUrl: () => (globalApps.config && globalApps.config.get('CCBaseUrl')) || '',
  getDefaultIsShortUrl: () => true,
  aidFetcher: () => globalApps.pageContext.aid,
  cidFetcher: () => globalApps.pageContext.cid,
  uidFetcher: () => globalApps.pageContext.uid,
});

export default UrlBuilders;
